import { Directive, ElementRef, OnInit, Renderer2 } from '@angular/core';
import { NavigationStart } from '@angular/router';
import { Meta } from '@df/core/meta/meta';
import { Logger } from '@df/core/service/logger';
import { ToggleService } from '@df/ui/toggle/toggle.service';
import { UiComponent } from '@df/ui/ui.component';
import { PageSearchService } from '../page-search.service';

export const pageHeaderSearchId = 'header';

@Directive({})
export abstract class AbstractPageSearchFormComponent extends UiComponent implements OnInit {
    /**
     * If form is visible
     */
    isVisible = false;

    /**
     * Header search status
     */
    get status() {
        return this.pageSearchService.status;
    }

    /**
     * Search term
     */
    term?: string;

    /**
     * Dependencies
     */
    constructor(
        protected elementRef: ElementRef,
        protected logger: Logger,
        private meta: Meta,
        protected renderer2: Renderer2,
        protected toggleService: ToggleService,
        private pageSearchService: PageSearchService
    ) {
        super();
    }

    /**
     * Initialization
     */
    override ngOnInit() {
        super.ngOnInit();
        // this.subscriptions.add(this.status.subscribe(() => this.detectChanges()));
        this.subscriptions.add(
            this.meta.routerEvents.subscribe(event => {
                if (event instanceof NavigationStart) {
                    this.toggleVisibility(false);
                }
            })
        );
    }

    /**
     * Toggle full component visibility
     */
    abstract toggleVisibility(to: boolean): void;

    /**
     * Action on input focus (or search icon click)
     */
    onInputFocus() {
        this.toggleVisibility(true);
    }

    /**
     * Action on input key up
     */
    onInputKeyUp(event: KeyboardEvent) {
        if (event.key === 'Enter' || event.code === 'Enter') {
            this.goToSearchView();
        } else if (event.key === 'Escape') {
            this.toggleVisibility(false);
        } else {
            this.applyTermChange();
        }
    }

    /**
     * Redirects to full search results page
     */
    goToSearchView() {
        this.pageSearchService.gotToSearchView(this.term);
    }

    /**
     * Resets state after it got closed
     */
    protected reset() {
        this.timeoutService.setTimeout(() => {
            this.term = undefined;
            this.pageSearchService.reset();
            this.detectChanges();
        }, 250); // lets reset AFTER its closed
    }

    /**
     * Throttled search function called on typing
     */
    // eslint-disable-next-line @typescript-eslint/member-ordering
    private applyTermChange = this.timeoutService.throttle(
        () => {
            this.detectChanges();
            if (this.term) {
                this.pageSearchService.search(this.term);
            }
        },
        500,
        {
            leading: false,
            trailing: true
        }
    );
}
